import { render, staticRenderFns } from "./DB.vue?vue&type=template&id=184264b2&"
import script from "./DB.vue?vue&type=script&lang=js&"
export * from "./DB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports